export default {
  vertSmall: '(max-width: 370px) and (min-height: 650px)',
  small: '(max-width: 480px)',
  medium: '(max-width: 700px)',
  large: '(max-width: 960px)',
};






// export default {
//   vertSmall: '(min-width: 370px) and (min-height: 650px)',
//   small: '(min-width: 480px)',
//   medium: '(min-width: 700px)',
//   large: '(min-width: 960px)',
// };
